import React from "react";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";

const AutomatedClearingHouse = ({ data }) => {
  const {
    ov_ach_account,
    ov_ach_bank,
    ov_ach_odfi,
    ov_ach_routing,
  } = data["4_3"];

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">
            Automated Clearing House Facility – ACH
          </div>
        </div>
        <React.Fragment>
          <ReviewAttribute
            label="ODFI institute"
            value={ov_ach_odfi?.length ? ov_ach_odfi : "-"}
          />
          <ReviewAttribute
            label="Settlement Bank"
            value={ov_ach_bank?.length ? ov_ach_bank : "-"}
          />
          <ReviewAttribute
            label="Settlement Account"
            value={ov_ach_account?.length ? ov_ach_account : "-"}
          />
          <ReviewAttribute
            label="Settlement Routing Number"
            value={ov_ach_routing?.length ? ov_ach_routing : "-"}
          />
        </React.Fragment>
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default AutomatedClearingHouse;
